import { Duration as PrimaryDuration, timeUnitMap } from './Duration.component';

const Duration: typeof PrimaryDuration & {
  TimeUnitMap?: typeof timeUnitMap;
} = PrimaryDuration;

Duration.TimeUnitMap = timeUnitMap;

export { Duration };
